import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const REPORT_DIGESTS_QUERY_KEY = "reportDigests";

/** Invalidates the caller's weekly board digests after one is saved or stopped. */
export const useInvalidateReportDigests = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [REPORT_DIGESTS_QUERY_KEY]
    });
  }, [queryClient]);
};
